import { render, staticRenderFns } from "./ListMetal.vue?vue&type=template&id=1d73317e&scoped=true&"
import script from "./ListMetal.vue?vue&type=script&lang=js&"
export * from "./ListMetal.vue?vue&type=script&lang=js&"
import style0 from "./ListMetal.vue?vue&type=style&index=0&id=1d73317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73317e",
  null
  
)

export default component.exports